import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Marquee from "@/components/Marquee";
import { Overline, Reveal } from "@/components/Reveal";
import { BIO_TIMELINE, CANDIDATE, IMAGES } from "@/data/campaign";

const About = () => (
  <main data-testid="about-page" className="pt-28 lg:pt-32">
    <section className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Overline>Meet the Candidate</Overline>
        <h1 className="mt-4 max-w-3xl font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
          Experience that puts <span className="italic text-terra-500">residents first.</span>
        </h1>
      </Reveal>

      <div className="mt-16 grid gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="img-frame sticky top-28 overflow-hidden">
            <img
              src={IMAGES.portraitBio}
              alt="Amin Nanji with volunteers at a community food drive in Ward 11"
              data-testid="about-portrait"
              loading="lazy"
              className="h-96 w-full object-cover sm:h-[520px]"
            />
            <div className="border-t border-pine-700/10 bg-paper p-5">
              <p className="font-serif text-lg italic text-pine-700">“{CANDIDATE.quote}”</p>
              <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-ink/50">
                Amin Nanji · Ward 11 resident for 30+ years
              </p>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          {BIO_TIMELINE.map((chapter, i) => (
            <Reveal key={chapter.title} delay={0.05} className="border-t border-pine-700/15 py-10 first:border-t-0 first:pt-0">
              <div className="grid gap-4 sm:grid-cols-[130px_1fr]">
                <span className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-terra-500">
                  {chapter.period}
                </span>
                <div>
                  <h2 className="font-serif text-2xl font-medium tracking-tight sm:text-3xl">{chapter.title}</h2>
                  <p className="mt-4 text-base leading-relaxed text-ink/75">{chapter.text}</p>
                </div>
              </div>
            </Reveal>
          ))}

          <Reveal className="mt-4 bg-pine-900 p-10 text-paper">
            <Overline light>Why I’m Running</Overline>
            <p className="mt-4 font-serif text-xl italic leading-relaxed text-paper/90 sm:text-2xl">
              Our neighbourhoods deserve a representative who understands the challenges we face, respects every tax
              dollar, and treats residents as partners — not afterthoughts.
            </p>
            <Link
              to="/get-involved"
              data-testid="about-join-button"
              className="group mt-8 inline-flex items-center gap-2 bg-terra-500 px-7 py-4 text-sm font-semibold text-paper transition-colors hover:bg-terra-600"
            >
              Join the Campaign
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>

    <div className="mt-24">
      <Marquee dark={false} />
    </div>
  </main>
);

export default About;
